﻿import {getViewportSize} from './viewport-checker';
import viewportSize from "./viewport-size";

const elements = {};
let currentViewport;

function setupMovingElements($) {
    $(window).on('resize', (_) => updateViewportSize(false));

    registerMovableElements($);

    updateViewportSize(true);

    // add functions to the window object so we can call them from other scripts
    window.addMovedViewportListener = addMovedViewportListener
    window.moveElementsToCurrentViewport = moveElementsToCurrentViewport
}

function updateViewportSize(initialMove) {
    const currentSize = getViewportSize();
    if (currentViewport !== currentSize) {
        moveElementsTo(currentSize, initialMove);
        $(document).trigger('viewport-changed', {from: currentViewport, to: currentSize});
    }
    currentViewport = currentSize;
}

function getSmallestAvailableViewport(moveableElements, size) {
    const viewportSizes = [viewportSize.xs, viewportSize.sm, viewportSize.md, viewportSize.lg, viewportSize.xl, viewportSize.xxl];

    // make sure we start from the current viewport size
    const startIndex = viewportSizes.indexOf(size);

    for (let i = startIndex; i < viewportSizes.length; i++) {
        const element = moveableElements[viewportSizes[i]]();
        if (element.length) {
            return element;
        }
    }

    // If no element found, default to the largest size
    return moveableElements[viewportSize.xxl]();
}

function moveElementsTo(currentSize, initialMove) {
    for (let key in elements) {
        if (elements.hasOwnProperty(key)) {
            const moveableElement = elements[key];
            const port = getSmallestAvailableViewport(moveableElement, currentSize);

            if (port.get(0) !== moveableElement.contents.parent().get(0)) {
                moveableElement.contents.appendTo(port);
                onMovedViewport(moveableElement, initialMove);
            }
        }
    }
}

function moveElementsToCurrentViewport(initialMove) {
    moveElementsTo(currentViewport, initialMove);
}

function registerMovableElements($, overwrite) {
    $('[data-responsive-movable]').each(function (index, element) {
        const $element = $(element);
        const key = $element.data('responsive-movable');
        if (elements[key] && !overwrite)
            return;
        elements[key] = {
            contents: $element.children(),
            ...generateViewportFunctions($element, key)
        };
    });
}

function generateViewportFunctions($element, key) {
    const viewportFunctions = Object.keys(viewportSize).reduce((functions, size) => {
        if (size !== 'xxl') {
            const targetElement = $(`[data-responsive-movable-${size}="${key}"]`).eq(0);
            functions[viewportSize[size]] = function () {
                return targetElement;
            }
        } else {
            functions[viewportSize.xxl] = function () {
                return $element;
            }
        }
        return functions;
    }, {});
    return viewportFunctions;
}

// store an array of listener functions
let movedViewportListeners = [];

/**
 * Registers a new listener to be called when the viewport is moved.
 *
 * @param {Function} fn - The listener function. This function will be called with two arguments:
 *                        1. The element that was moved.
 *                        2. A boolean indicating whether this was the initial move.
 */
function addMovedViewportListener(fn) {
    if (typeof fn === 'function') {
        movedViewportListeners.push(fn);
    } else {
        console.error('addMoveListener expects a function');
    }
}


/**
 * Called when an element is moved to a different viewport.
 * This function will call all registered listeners.
 *
 * @param {Object} element - The element that was moved.
 * @param {boolean} initialMove - Indicates whether this was the initial move.
 */
function onMovedViewport(element, initialMove) {
    movedViewportListeners.forEach((listener) => {
        try {
            listener(element, initialMove);
        } catch (error) {
            console.error(`An error occurred in move listener: ${error}`);
        }
    });
}

/**
 * Adds a listener function to be called when an element is moved to a different viewport.
 * The function should take two arguments:
 * - the element that was moved,
 * - a boolean indicating whether this was the initial move.
 *
 * @param {Function} fn - The listener function.
 */
window.addMovedViewportListener = addMovedViewportListener;

/**
 * Moves elements to the current viewport.
 * Intended to be used when the viewport size has changed.
 *
 * @param {boolean} initialMove - Indicates whether this is the initial move.
 */
window.moveElementsToCurrentViewport = moveElementsToCurrentViewport;

window.registerMovableElements = registerMovableElements;

export default setupMovingElements;
